import { AutoTaskRow } from './autoTaskRow.ts';


/** Orders prepared tasks by urgency, task type, and remaining time. */
export function sortAutoTasks(rows: AutoTaskRow[]) {
    rows.sort(autoTaskCompare);
}

function autoTaskCompare(a: AutoTaskRow, b: AutoTaskRow) {
    const order = compareTaskUp(a, b)
        || compareTaskTypeIf(a, b)
        || compareTimeRemaining(a, b);
    return order;
}

function compareTaskUp(a: AutoTaskRow, b: AutoTaskRow) {
    const order = +isTaskUp(b) - +isTaskUp(a);
    return order;
}

function isTaskUp(row: AutoTaskRow): boolean {
    const taskUp = row.kind !== 'task' || !!row.task.isTaskUp;
    return taskUp;
}

// Only sort by task type if task is up.
function compareTaskTypeIf(a: AutoTaskRow, b: AutoTaskRow) {
    if (!isTaskUp(a) && !isTaskUp(b)) {
        return 0;
    }
    const order = getRank(a) - getRank(b);
    return order;
}

function getRank(row: AutoTaskRow): number {
    if (row.kind === 'disconnectedSummary') {
        return 4;
    }
    if (row.kind === 'fixSummary') {
        return 5;
    }
    switch (row.task.type) {
        case 'workCounter':
            return 1;
        case 'help':
            return 2;
        case 'toolChange':
            return 3;
        case 'disconnected':
            return 4;
        case 'measure':
            return 6;
        case 'fixInProgress':
            return 5;
    }
}

function compareTimeRemaining(a: AutoTaskRow, b: AutoTaskRow) {
    if (a.kind !== 'task' || b.kind !== 'task') {
        return 0;
    }
    const order = a.timeRemaining - b.timeRemaining;
    return order;
}
